import { render } from "./UserCenterSkeleton.vue?vue&type=template&id=bc8694ce&scoped=true"
const script = {}

import "./UserCenterSkeleton.vue?vue&type=style&index=0&id=bc8694ce&scoped=true&lang=css"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8694ce"]])

export default __exports__